const getRequiredEnv = (name) => {
  const value = process.env[name];
  if (!value) {
    throw new Error(`Missing required environment variable: ${name}`);
  }
  return value;
};

const API_BASE_URL = getRequiredEnv("REACT_APP_API_BASE_URL");
const WS_BASE_URL = getRequiredEnv("REACT_APP_WS_BASE_URL");
const ERP_BASE_URL = getRequiredEnv("REACT_APP_ERP_BASE_URL");
const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";
const FRONT_LOG_INGEST_ENABLED = process.env.REACT_APP_FRONT_LOG_INGEST_ENABLED === "true";
const AUTH_MODE = (process.env.REACT_APP_AUTH_MODE || "legacy").toLowerCase();
const COGNITO_REGION = process.env.REACT_APP_COGNITO_REGION || "";
const COGNITO_USER_POOL_ID = process.env.REACT_APP_COGNITO_USER_POOL_ID || "";
const COGNITO_APP_CLIENT_ID = process.env.REACT_APP_COGNITO_APP_CLIENT_ID || "";
const COGNITO_DOMAIN = process.env.REACT_APP_COGNITO_DOMAIN || "";
const COGNITO_REDIRECT_SIGN_IN = process.env.REACT_APP_COGNITO_REDIRECT_SIGN_IN || "";
const COGNITO_REDIRECT_SIGN_OUT = process.env.REACT_APP_COGNITO_REDIRECT_SIGN_OUT || "";
const FRONT_VERSION = process.env.REACT_APP_FRONT_VERSION || "2.0.1";

export {
  API_BASE_URL,
  WS_BASE_URL,
  ERP_BASE_URL,
  GOOGLE_MAPS_API_KEY,
  FRONT_LOG_INGEST_ENABLED,
  AUTH_MODE,
  COGNITO_REGION,
  COGNITO_USER_POOL_ID,
  COGNITO_APP_CLIENT_ID,
  COGNITO_DOMAIN,
  COGNITO_REDIRECT_SIGN_IN,
  COGNITO_REDIRECT_SIGN_OUT,
  FRONT_VERSION,
};
